import { useSyncExternalStore } from 'react'

// Reminders that should not pop up again until the next load: closed in the window,
// or just set by the person themselves — a reminder «for today» needs no window right after it was typed.
// Keyed by note and day: a reminder moved to tomorrow is a new one and pops up tomorrow in a tab left open.

let seen: ReadonlySet<string> = new Set()
const listeners = new Set<() => void>()

const notify = () => listeners.forEach((listener) => listener())

export const reminderKey = (note: { id: string; remindOn: string | null }): string => `${note.id}:${note.remindOn}`

export function markRemindersSeen(keys: readonly string[]): void {
  if (keys.every((key) => seen.has(key))) return
  seen = new Set([...seen, ...keys])
  notify()
}

/** Another person may sign in in the same tab. */
export function resetSeenReminders(): void {
  seen = new Set()
  notify()
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const useSeenReminders = (): ReadonlySet<string> => useSyncExternalStore(subscribe, () => seen)
